/** Service Desk workflows integration: mirror of backend `app/core/constants/workflow_service.py`.
 *  Generated once from the backend constants; `tests/core/test_service_desk_mirror.py` keeps the two equal. */

export const SERVICE_TRIGGER_VALUES = [
  "ticket_created",
  "ticket_updated",
  "ticket_state_changed",
  "ticket_assigned",
  "ticket_returned_to_queue",
  "ticket_customer_replied",
  "ticket_staff_replied",
  "ticket_note_added",
  "ticket_sla_warning",
  "ticket_sla_breached",
  "ticket_unassigned_due",
  "ticket_waiting_reminder_due",
  "ticket_pending_expired",
  "ticket_resolved",
  "ticket_reopened",
  "ticket_auto_close_due",
  "ticket_csat_received",
  "ticket_intake_requested",
  "order_placed",
  "order_status_changed",
  "order_approval_requested",
  "order_approval_decided",
  "order_sync_failed",
  "quote_status_changed",
  "visit_scheduled",
  "visit_status_changed",
  "visit_reminder_due",
  "asset_maintenance_due",
  "asset_warranty_expiring",
  "contract_expiring",
  "rma_status_changed",
  "catalogue_sync_finished",
] as const;
export type ServiceTrigger = (typeof SERVICE_TRIGGER_VALUES)[number];

export const CONNECTOR_EVENT_TRIGGER = "connector_event_received" as const;

export const SERVICE_FACING_TRIGGERS = ["ticket_intake_requested"] as const;

export const TRIGGER_MIN_PLAN = {
  ticket_created: "standard",
  ticket_updated: "standard",
  ticket_state_changed: "standard",
  ticket_assigned: "standard",
  ticket_returned_to_queue: "standard",
  ticket_customer_replied: "standard",
  ticket_staff_replied: "standard",
  ticket_note_added: "standard",
  ticket_sla_warning: "standard",
  ticket_sla_breached: "standard",
  ticket_unassigned_due: "standard",
  ticket_waiting_reminder_due: "standard",
  ticket_pending_expired: "standard",
  ticket_resolved: "standard",
  ticket_reopened: "standard",
  ticket_auto_close_due: "standard",
  ticket_csat_received: "standard",
  ticket_intake_requested: "standard",
  order_placed: "pro",
  order_status_changed: "pro",
  order_approval_requested: "pro",
  order_approval_decided: "pro",
  order_sync_failed: "pro",
  quote_status_changed: "pro",
  visit_scheduled: "pro",
  visit_status_changed: "pro",
  visit_reminder_due: "pro",
  asset_maintenance_due: "pro",
  asset_warranty_expiring: "pro",
  contract_expiring: "pro",
  rma_status_changed: "pro",
  catalogue_sync_finished: "pro",
} as const;

export const TRIGGER_PHASE = {
  ticket_created: "S1",
  ticket_updated: "S1",
  ticket_state_changed: "S1",
  ticket_assigned: "S1",
  ticket_returned_to_queue: "S1",
  ticket_customer_replied: "S1",
  ticket_staff_replied: "S1",
  ticket_note_added: "S1",
  ticket_sla_warning: "S1",
  ticket_sla_breached: "S1",
  ticket_unassigned_due: "S1",
  ticket_waiting_reminder_due: "S1",
  ticket_pending_expired: "S1",
  ticket_resolved: "S1",
  ticket_reopened: "S1",
  ticket_auto_close_due: "S1",
  ticket_csat_received: "S1",
  ticket_intake_requested: "S1",
  order_placed: "S2",
  order_status_changed: "S2",
  order_approval_requested: "S2",
  order_approval_decided: "S2",
  order_sync_failed: "S2",
  quote_status_changed: "S2",
  visit_scheduled: "S3",
  visit_status_changed: "S3",
  visit_reminder_due: "S3",
  asset_maintenance_due: "S3",
  asset_warranty_expiring: "S3",
  contract_expiring: "S3",
  rma_status_changed: "S3",
  catalogue_sync_finished: "S2",
} as const;

export const S1_SERVICE_TRIGGERS = [
  "ticket_created",
  "ticket_updated",
  "ticket_state_changed",
  "ticket_assigned",
  "ticket_returned_to_queue",
  "ticket_customer_replied",
  "ticket_staff_replied",
  "ticket_note_added",
  "ticket_sla_warning",
  "ticket_sla_breached",
  "ticket_unassigned_due",
  "ticket_waiting_reminder_due",
  "ticket_pending_expired",
  "ticket_resolved",
  "ticket_reopened",
  "ticket_auto_close_due",
  "ticket_csat_received",
  "ticket_intake_requested",
] as const;

export const SERVICE_STEP_VALUES = [
  "ticket_intake",
  "show_ticket_form",
  "show_my_tickets",
  "create_ticket",
  "update_ticket",
  "set_ticket_state",
  "route_ticket",
  "assign_ticket",
  "add_ticket_note",
  "reply_to_ticket",
  "notify_contact",
  "link_ticket",
  "apply_ticket_sla",
  "request_csat",
  "lookup_asset",
  "schedule_visit",
  "request_visit",
  "lookup_catalogue",
  "show_catalogue",
  "create_order",
  "check_order_status",
  "show_order_status",
] as const;
export type ServiceStep = (typeof SERVICE_STEP_VALUES)[number];

export const STEP_SPECS = {
  ticket_intake: { exits: ["submitted", "duplicate_used", "abandoned", "needs_person"], facing: true, minPlan: "standard", phase: "S1" },
  show_ticket_form: { exits: ["submitted", "not_submitted"], facing: true, minPlan: "standard", phase: "S1" },
  show_my_tickets: { exits: ["shown", "not_verified"], facing: true, minPlan: "standard", phase: "S1" },
  create_ticket: { exits: ["success", "failure"], facing: false, minPlan: "standard", phase: "S1" },
  update_ticket: { exits: ["success", "failure"], facing: false, minPlan: "standard", phase: "S1" },
  set_ticket_state: { exits: ["success", "failure"], facing: false, minPlan: "standard", phase: "S1" },
  route_ticket: { exits: ["assigned", "queued"], facing: false, minPlan: "standard", phase: "S1" },
  assign_ticket: { exits: ["success", "failure"], facing: false, minPlan: "standard", phase: "S1" },
  add_ticket_note: { exits: [], facing: false, minPlan: "standard", phase: "S1" },
  reply_to_ticket: { exits: [], facing: false, minPlan: "standard", phase: "S1" },
  notify_contact: { exits: ["sent", "skipped"], facing: false, minPlan: "standard", phase: "S1" },
  link_ticket: { exits: [], facing: false, minPlan: "standard", phase: "S1" },
  apply_ticket_sla: { exits: [], facing: false, minPlan: "pro", phase: "S1" },
  request_csat: { exits: ["sent", "skipped"], facing: false, minPlan: "standard", phase: "S1" },
  lookup_asset: { exits: ["found", "not_found"], facing: false, minPlan: "pro", phase: "S3" },
  schedule_visit: { exits: ["success", "failure"], facing: false, minPlan: "pro", phase: "S3" },
  request_visit: { exits: ["scheduled", "requested", "not_scheduled"], facing: true, minPlan: "pro", phase: "S3" },
  lookup_catalogue: { exits: ["found", "not_found"], facing: false, minPlan: "pro", phase: "S2" },
  show_catalogue: { exits: ["added_to_cart", "closed"], facing: true, minPlan: "pro", phase: "S2" },
  create_order: { exits: ["placed", "sent_for_approval", "cancelled", "failed"], facing: true, minPlan: "pro", phase: "S2" },
  check_order_status: { exits: ["success", "failure"], facing: false, minPlan: "pro", phase: "S2" },
  show_order_status: { exits: ["shown", "not_verified"], facing: true, minPlan: "pro", phase: "S2" },
} as const;

export const SYSTEM_STEP_ALLOWLIST_ADDITIONS = [
  "route_ticket",
  "assign_ticket",
  "notify_contact",
  "set_ticket_state",
  "add_ticket_note",
  "request_csat",
  "create_ticket",
  "schedule_visit",
  "link_ticket",
  "update_ticket",
] as const;

export const REPLY_TO_TICKET_CAP_PER_RUN = 3 as const;

/** The eleven S1 background steps in the order of the scope (backend `SERVICE_BACKGROUND_STEPS`). */
export const SERVICE_BACKGROUND_STEP_TYPES = [
  "create_ticket",
  "update_ticket",
  "set_ticket_state",
  "route_ticket",
  "assign_ticket",
  "add_ticket_note",
  "reply_to_ticket",
  "notify_contact",
  "link_ticket",
  "apply_ticket_sla",
  "request_csat",
] as const;
export type ServiceBackgroundStepType = (typeof SERVICE_BACKGROUND_STEP_TYPES)[number];

/** The three customer-facing ticket steps (backend `TICKET_FACING_CLASSES`, SD-S1-34): the assistant takes the concern, the static form, the client's open requests. */
export const SERVICE_FACING_STEP_TYPES = ["ticket_intake", "show_ticket_form", "show_my_tickets"] as const;
export type ServiceFacingStepType = (typeof SERVICE_FACING_STEP_TYPES)[number];

/** `caps` token of a chat client that draws the ticket cards (backend `CAP_SERVICE_STEPS`); also sent in the `X-Sagot-Client-Caps` header. */
export const SERVICE_STEPS_CAP = "service_steps";
export const SERVICE_CLIENT_CAPS_HEADER = "X-Sagot-Client-Caps";

/** `kind` of the `workflow_step` cards the ticket steps add (backend `TicketCardKind`). */
export const SERVICE_CARD_KINDS = ["ticket_summary", "ticket_receipt", "ticket_duplicate", "ticket_form", "my_tickets"] as const;
export type ServiceCardKind = (typeof SERVICE_CARD_KINDS)[number];

/** Reserved button ids of the answer-first path ("That solved it" is the deflection of metric M5) and of the ticket cards. */
export const SERVICE_BUTTON_IDS = { solved: "solved", stillNeedHelp: "still_need_help", submit: "submit", cancel: "cancel", newTicket: "new_ticket" } as const;

/** The field of a step that holds the path an exit leads to (backend `EXIT_FIELDS`). */
/** After-sales (M27 S3, scope 14.3): the two background steps that find an asset and propose a visit. The builder forms for them come with the field-service console. */
export const AFTER_SALES_STEP_TYPES = ["lookup_asset", "schedule_visit"] as const;

/** Orders (M27 S2, SD-S2-16; backend `COMMERCE_BACKGROUND_STEPS` / `COMMERCE_FACING_STEPS`): search the catalogue and read an order behind the scenes; show products, review the cart and show orders to the client. */
export const COMMERCE_BACKGROUND_STEP_TYPES = ["lookup_catalogue", "check_order_status"] as const;
export const COMMERCE_FACING_STEP_TYPES = ["show_catalogue", "create_order", "show_order_status"] as const;

export const SERVICE_EXIT_FIELDS = {
  success: "success_goto",
  failure: "failure_goto",
  assigned: "assigned_goto",
  queued: "queued_goto",
  sent: "sent_goto",
  skipped: "skipped_goto",
  found: "found_goto",
  not_found: "not_found_goto",
} as const;

export const CONDITION_FACTS = {
  ticket: [
    "number",
    "type",
    "category",
    "status",
    "status_category",
    "priority",
    "channel",
    "team_id",
    "assignee",
    "assignee_id",
    "tags",
    "organisation_id",
    "org_tier",
    "site_region",
    "asset_category",
    "has_asset",
    "contract_active",
    "warranty_status",
    "sla_policy",
    "sla.first_response_state",
    "sla.resolution_state",
    "reopen_count",
    "requester_verified",
    "language",
    "origin",
    "field.<key>",
    "created_in_office_hours",
    "sentiment",
  ],
  organisation: ["id", "tier", "industry", "status", "tags", "attr.<key>"],
  contact: ["org_role", "can_order", "verified", "verified_via", "language", "attr.<key>"],
  asset: ["category", "model", "manufacturer", "warranty_status", "next_pm_due_in_days"],
  order: ["status", "total_php", "approval_state", "kind", "connector_id", "line_count", "has_backorder"],
  visit: ["kind", "status", "engineer_id", "window_start"],
  event: ["changed", "from", "to", "score", "low", "outcome", "metric", "n", "reason", "audience", "rescheduled", "mentions"],
} as const;

export const EVENT_METRICS = ["first_response", "next_response", "resolution", "onsite_response"] as const;

export const DEFAULT_AREA_VALUES = ["service_desk", "orders_field_service"] as const;
export type DefaultArea = (typeof DEFAULT_AREA_VALUES)[number];

export const EXECUTION_VALUES = ["inline", "async", "facing"] as const;
export type Execution = (typeof EXECUTION_VALUES)[number];

/**
 * The Service Desk defaults. `live` is the state the backend file (`workflow-defaults.json`, `initial_state`)
 * provisions: `false` = starts paused (the visit/warranty/contract defaults of field service, the handoff ticket,
 * and the four order defaults WD-17/18/27/28 whose e-mails the order jobs still send themselves).
 */
export const DEFAULT_WORKFLOWS = [
  { wd: "WD-01", systemKey: "ticket_route_and_alert", name: "Route and alert new tickets", trigger: "ticket_created", execution: "inline", area: "service_desk", live: true },
  {
    wd: "WD-02",
    systemKey: "ticket_assignment_alert",
    name: "Tell people when a ticket is assigned to them",
    trigger: "ticket_assigned",
    execution: "inline",
    area: "service_desk",
    live: true,
  },
  { wd: "WD-03", systemKey: "ticket_received_client", name: "Confirm new tickets to the client", trigger: "ticket_created", execution: "async", area: "service_desk", live: true },
  { wd: "WD-04", systemKey: "ticket_reply_client", name: "Send staff replies to the client", trigger: "ticket_staff_replied", execution: "async", area: "service_desk", live: true },
  { wd: "WD-05", systemKey: "ticket_status_client", name: "Tell the client when the status changes", trigger: "ticket_state_changed", execution: "async", area: "service_desk", live: true },
  { wd: "WD-06", systemKey: "ticket_sla_breach_alert", name: "Alert when a ticket SLA is breached", trigger: "ticket_sla_breached", execution: "async", area: "service_desk", live: true },
  {
    wd: "WD-07",
    systemKey: "ticket_unassigned_escalation",
    name: "Escalate tickets nobody picked up",
    trigger: "ticket_unassigned_due",
    execution: "async",
    area: "service_desk",
    live: true,
  },
  {
    wd: "WD-08",
    systemKey: "ticket_waiting_reminder",
    name: "Remind clients we need their reply",
    trigger: "ticket_waiting_reminder_due",
    execution: "async",
    area: "service_desk",
    live: true,
  },
  { wd: "WD-09", systemKey: "ticket_auto_close", name: "Close resolved tickets after a few days", trigger: "ticket_auto_close_due", execution: "inline", area: "service_desk", live: true },
  { wd: "WD-10", systemKey: "ticket_csat_request", name: "Ask for a rating when a ticket is resolved", trigger: "ticket_resolved", execution: "async", area: "service_desk", live: true },
  { wd: "WD-11", systemKey: "ticket_low_csat_alert", name: "Alert the team lead about low ratings", trigger: "ticket_csat_received", execution: "async", area: "service_desk", live: true },
  {
    wd: "WD-12",
    systemKey: "ticket_client_replied_alert",
    name: "Tell the assignee when the client replies",
    trigger: "ticket_customer_replied",
    execution: "inline",
    area: "service_desk",
    live: true,
  },
  { wd: "WD-13", systemKey: "visit_scheduled_client", name: "Confirm visits to the client", trigger: "visit_scheduled", execution: "async", area: "orders_field_service", live: true },
  {
    wd: "WD-14",
    systemKey: "visit_reminders",
    name: "Remind client and engineer before a visit",
    trigger: "visit_reminder_due",
    execution: "async",
    area: "orders_field_service",
    live: true,
  },
  {
    wd: "WD-15",
    systemKey: "visit_report_client",
    name: "Send the visit report to the client",
    trigger: "visit_status_changed",
    execution: "async",
    area: "orders_field_service",
    live: true,
  },
  { wd: "WD-16", systemKey: "order_placed_alert", name: "Confirm orders and alert sales", trigger: "order_placed", execution: "async", area: "orders_field_service", live: true },
  {
    wd: "WD-17",
    systemKey: "order_approval_request",
    name: "Ask approvers to approve an order",
    trigger: "order_approval_requested",
    execution: "async",
    area: "orders_field_service",
    live: false,
  },
  {
    wd: "WD-18",
    systemKey: "order_status_client",
    name: "Tell clients about shipping and delivery",
    trigger: "order_status_changed",
    execution: "async",
    area: "orders_field_service",
    live: false,
  },
  { wd: "WD-19", systemKey: "quote_ready_client", name: "Tell clients their quote is ready", trigger: "quote_status_changed", execution: "async", area: "orders_field_service", live: true },
  { wd: "WD-20", systemKey: "concern_intake", name: "Turn concerns into tickets", trigger: "ticket_intake_requested", execution: "facing", area: "service_desk", live: true },
  { wd: "WD-21", systemKey: "handoff_to_ticket", name: "Create a ticket for out-of-hours handoffs", trigger: "handoff_requested", execution: "async", area: "service_desk", live: false },
  {
    wd: "WD-22",
    systemKey: "maintenance_due_ticket",
    name: "Open maintenance tickets when PM is due",
    trigger: "asset_maintenance_due",
    execution: "async",
    area: "orders_field_service",
    live: false,
  },
  {
    wd: "WD-23",
    systemKey: "warranty_expiring_notice",
    name: "Tell clients a warranty is ending",
    trigger: "asset_warranty_expiring",
    execution: "async",
    area: "orders_field_service",
    live: false,
  },
  { wd: "WD-24", systemKey: "contract_renewal_ticket", name: "Start contract renewals", trigger: "contract_expiring", execution: "async", area: "orders_field_service", live: false },
  { wd: "WD-25", systemKey: "ticket_sla_warning_alert", name: "Warn before a ticket SLA is breached", trigger: "ticket_sla_warning", execution: "async", area: "service_desk", live: true },
  {
    wd: "WD-26",
    systemKey: "ticket_pending_auto_resolve",
    name: "Resolve tickets when the client doesn't reply",
    trigger: "ticket_pending_expired",
    execution: "inline",
    area: "service_desk",
    live: true,
  },
  {
    wd: "WD-27",
    systemKey: "order_approval_result",
    name: "Tell the requester about the approval",
    trigger: "order_approval_decided",
    execution: "async",
    area: "orders_field_service",
    live: false,
  },
  {
    wd: "WD-28",
    systemKey: "order_sync_failed_alert",
    name: "Alert sales when an order can't be sent",
    trigger: "order_sync_failed",
    execution: "async",
    area: "orders_field_service",
    live: false,
  },
  {
    wd: "WD-29",
    systemKey: "ticket_returned_to_queue_alert",
    name: "Alert the team when a ticket returns to the queue",
    trigger: "ticket_returned_to_queue",
    execution: "inline",
    area: "service_desk",
    live: true,
  },
  {
    wd: "WD-30",
    systemKey: "ticket_mention_alert",
    name: "Tell people when they're mentioned in a note",
    trigger: "ticket_note_added",
    execution: "inline",
    area: "service_desk",
    live: true,
  },
] as const;
export type DefaultWorkflow = (typeof DEFAULT_WORKFLOWS)[number];

export const HIGH_IMPACT_DEFAULTS = ["ticket_reply_client", "order_approval_request", "order_sync_failed_alert"] as const;

export const SERVICE_TEMPLATES = [
  "vip_org_priority",
  "urgent_after_hours_page",
  "ticket_due_date_reminder",
  "handover_welcome",
  "reorder_consumables_reminder",
  "warranty_claim_triage",
  "negative_sentiment_escalation",
  "order_issue_fast_lane",
] as const;

export const PRO_SERVICE_TEMPLATES = ["reorder_consumables_reminder", "warranty_claim_triage"] as const;

export const CLIENT_EMAIL_TEMPLATES = [
  "ticket_received",
  "ticket_reply",
  "ticket_status",
  "ticket_waiting_reminder",
  "ticket_resolved",
  "visit_scheduled",
  "visit_changed",
  "visit_reminder",
  "visit_report",
  "order_received",
  "order_approval_request",
  "order_approval_result",
  "order_status",
  "quote_ready",
  "magic_link",
] as const;

export const SERVICE_WEBHOOK_EVENTS = [
  { name: "ticket.created", triggers: ["ticket_created"] },
  { name: "ticket.updated", triggers: ["ticket_updated"] },
  { name: "ticket.state_changed", triggers: ["ticket_state_changed"] },
  { name: "ticket.assigned", triggers: ["ticket_assigned"] },
  { name: "ticket.message_created", triggers: ["ticket_customer_replied", "ticket_staff_replied"] },
  { name: "ticket.note_added", triggers: ["ticket_note_added"] },
  { name: "ticket.sla_warning", triggers: ["ticket_sla_warning"] },
  { name: "ticket.sla_breached", triggers: ["ticket_sla_breached"] },
  { name: "ticket.resolved", triggers: ["ticket_resolved"] },
  { name: "ticket.reopened", triggers: ["ticket_reopened"] },
  { name: "ticket.closed", triggers: [] },
  { name: "ticket.merged", triggers: [] },
  { name: "ticket.csat_received", triggers: ["ticket_csat_received"] },
  { name: "organisation.created", triggers: [] },
  { name: "organisation.updated", triggers: [] },
  { name: "contact.created", triggers: [] },
  { name: "contact.updated", triggers: [] },
  { name: "contact.verified", triggers: [] },
  { name: "asset.created", triggers: [] },
  { name: "asset.updated", triggers: [] },
  { name: "order.created", triggers: ["order_placed"] },
  { name: "order.status_changed", triggers: ["order_status_changed"] },
  { name: "order.approval_requested", triggers: ["order_approval_requested"] },
  { name: "order.approval_decided", triggers: ["order_approval_decided"] },
  { name: "order.sync_failed", triggers: ["order_sync_failed"] },
  { name: "quote.status_changed", triggers: ["quote_status_changed"] },
  { name: "visit.scheduled", triggers: ["visit_scheduled"] },
  { name: "visit.status_changed", triggers: ["visit_status_changed"] },
  { name: "rma.status_changed", triggers: ["rma_status_changed"] },
  { name: "contract.expiring", triggers: ["contract_expiring"] },
  { name: "catalogue.sync_finished", triggers: ["catalogue_sync_finished"] },
] as const;
export type WebhookEvent = (typeof SERVICE_WEBHOOK_EVENTS)[number];

export const INTERNAL_ONLY_TRIGGERS = [
  "ticket_returned_to_queue",
  "ticket_unassigned_due",
  "ticket_waiting_reminder_due",
  "ticket_pending_expired",
  "ticket_auto_close_due",
  "ticket_intake_requested",
  "visit_reminder_due",
  "asset_maintenance_due",
  "asset_warranty_expiring",
] as const;
